export const TEXTS = {
  LOGIN_TO_ACCOUNT: 'Войти в аккаунт',
  CANCEL: 'Отменить',
  LOGIN_REQUIRED_TITLE: 'Нужно войти в  ваш аккаунт',
};
